// component
import Iconify from '../../components/Iconify';

// ----------------------------------------------------------------------

const getIcon = (name) => <Iconify icon={name} width={22} height={22} />;

export const getNavConfig = (userRole) => {
  // Start with an empty config for every role
  let navConfig = [];

  if (userRole === 'user') {
    navConfig = [
      {
        title: 'profile',
        path: '/dashboard/profile',
        icon: getIcon('eva:person-fill'),
      },
    ];
    return navConfig; // Return early for 'user' role
  }

  // Base items for all roles except 'user'
  navConfig = [
    {
      title: 'dashboard',
      path: '/dashboard/app',
      icon: getIcon('eva:pie-chart-2-fill'),
    },
  ];

  if (userRole === 'superadmin') {
    navConfig.push(
      {
        title: 'Users',
        path: '#', // Use '#' to indicate a dropdown
        icon: getIcon('eva:people-fill'),
        children: [
          {
            title: 'user',
            path: '/dashboard/user',
            icon: getIcon('eva:people-fill'),
          },
          {
            title: 'individual user',
            path: '/dashboard/indivualuser',
            icon: getIcon('eva:people-fill'),
          },
          {
            title: 'industry user',
            path: '/dashboard/industryuser',
            icon: getIcon('eva:people-fill'),
          },
          {
            title: 'life member user',
            path: '/dashboard/lifememberuser',
            icon: getIcon('eva:people-fill'),
          },
          {
            title: 'senior citizen user',
            path: '/dashboard/seniorcitizenuser',
            icon: getIcon('eva:people-fill'),
          },
          {
            title: 'student user',
            path: '/dashboard/studentuser',
            icon: getIcon('eva:people-fill'),
          },
          {
            title: 'trade union user',
            path: '/dashboard/tradeunionuser',
            icon: getIcon('eva:people-fill'),
          },
          {
            title: 'association user',
            path: '/dashboard/associationuser',
            icon: getIcon('eva:people-fill'),
          },
          {
            title: 'institution user',
            path: '/dashboard/institutionuser',
            icon: getIcon('eva:people-fill'),
          },
        ],
      },
      {
        title: 'calendar',
        path: '/dashboard/calendar',
        icon: getIcon('eva:calendar-fill'),
      },
      {
        title: 'payment',
        path: '/dashboard/payment',
        icon: getIcon('eva:credit-card-fill'),
      },
      {
        title: 'profile',
        path: '/dashboard/profile',
        icon: getIcon('eva:person-fill'),
      },
      {
        title: 'company',
        path: '/dashboard/company',
        icon: getIcon('eva:home-fill'),
      }
    );
  } else if (userRole === 'admin') {
    navConfig.push(
      {
        title: 'Users',
        path: '#', // Use '#' to indicate a dropdown
        icon: getIcon('eva:people-fill'),
        children: [
          {
            title: 'individual user',
            path: '/dashboard/indivualuser',
            icon: getIcon('eva:people-fill'),
          },
          {
            title: 'industry user',
            path: '/dashboard/industryuser',
            icon: getIcon('eva:people-fill'),
          },
          {
            title: 'life member user',
            path: '/dashboard/lifememberuser',
            icon: getIcon('eva:people-fill'),
          },
          {
            title: 'senior citizen user',
            path: '/dashboard/seniorcitizenuser',
            icon: getIcon('eva:people-fill'),
          },
          {
            title: 'student user',
            path: '/dashboard/studentuser',
            icon: getIcon('eva:people-fill'),
          },
          {
            title: 'trade union user',
            path: '/dashboard/tradeunionuser',
            icon: getIcon('eva:people-fill'),
          },
          {
            title: 'association user',
            path: '/dashboard/associationuser',
            icon: getIcon('eva:people-fill'),
          },
          {
            title: 'institution user',
            path: '/dashboard/institutionuser',
            icon: getIcon('eva:people-fill'),
          },
        ],
      },
      {
        title: 'calendar',
        path: '/dashboard/calendar',
        icon: getIcon('eva:calendar-fill'),
      },
      {
        title: 'payment',
        path: '/dashboard/payment',
        icon: getIcon('eva:credit-card-fill'),
      },
      {
        title: 'profile',
        path: '/dashboard/profile',
        icon: getIcon('eva:person-fill'),
      },
      {
        title: 'company',
        path: '/dashboard/company',
        icon: getIcon('eva:home-fill'),
      }
    );
  } else if (userRole === 'team') {
    navConfig.push(
      {
        title: 'payment',
        path: '/dashboard/payment',
        icon: getIcon('eva:credit-card-fill'),
      },
      {
        title: 'calendar',
        path: '/dashboard/calendar',
        icon: getIcon('eva:calendar-fill'),
      },
      {
        title: 'profile',
        path: '/dashboard/profile',
        icon: getIcon('eva:person-fill'),
      },
   
    );
  }

  return navConfig;
};
